export default {
  "Cut Audio": "Cortar audio",
  "HitPaw Online Audio Cutter": "HitPaw Cortador de Audio Online",
  "Trim or cut any audio files online.": "Recorta o corta cualquier archivo de audio en línea.",
  "Cut": "Cortar",
  "Fade in": "Disolver de entrada",
  "Fade out": "Disolver de salida",
  "Cut from": "Cortar de",
  "to": "a",
  "Extract selection": "Extraer selección",
  "Delete selection": "Eliminar selección",
  "Adjust New": "Ajustar nuevo",
  "Cut New": "Cortar nuevo",
  "Adjust Volume": "Ajustar el volumen",
  "HitPaw Online Volume Changer": "HitPaw Ajustar el Volumen Online",
  "Turn up or Turn down the volume of audio.": "Sube o baja el volumen del audio.",
  "Volume": "Volumen",
  "Change Speed": "Cambiar la velocidad",
  "HitPaw Online Audio Speed Changer": "HitPaw Cambiar la Velocidad Online",
  "Speed up or slow down audios online easily.": "Acelera o ralentiza los audios en línea fácilmente.",
  "Speed": "Velocidad",
  "Format": "Formato",
  "Size": "Tamaño",
  "Duration": "Duración",
};
